export enum RequestAgencyStatus {
	Valid = "VALID",
	Expired = "EXPIRED",
}
